import React from 'react';
import '../../assets/css/authloading.css'

class authLoading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    return (
      <div className="loading_cont">
        <label className="label">Loading...</label>
        <div id="loader_auth">
          <div></div>
        </div>
      </div>
    )
  }
}
export default authLoading
